export function formatUserDisplayName(id: number, name?: string | null): string {
  return name || `User #${id}`;
}
